import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpecialCharDropdownComponent } from './dropdowns/special-char-dropdown/special-char-dropdown.component';
import { AccentedCharDropdownComponent } from './dropdowns/accented-char-dropdown/accented-char-dropdown.component';
import { BibleDropdownComponent } from './dropdowns/bible-dropdown/bible-dropdown.component';
import { LegalCodeDropdownComponent } from './dropdowns/legal-code-dropdown/legal-code-dropdown.component';
import { MishnaDropdownComponent } from './dropdowns/mishna-dropdown/mishna-dropdown.component';
import { TalmudBavliDropdownComponent } from './dropdowns/talmud-bavli-dropdown/talmud-bavli-dropdown.component';
import { TalmudYerushalmiDropdownComponent } from './dropdowns/talmud-yerushalmi-dropdown/talmud-yerushalmi-dropdown.component';
import { ToseftaDropdownComponent } from './dropdowns/tosefta-dropdown/tosefta-dropdown.component';
import { NoteDropdownComponent } from './dropdowns/note-dropdown/note-dropdown.component';
import { CustomEditorComponent } from './custom-editor.component';
import { FateHtmlParserService, FateIconService, FateMaterialModule, FateModule, FateParserService } from 'fate-editor';
import { CustomHtmlParserService } from './services/custom-html-parser.service';
import { CustomParserService } from './services/custom-parser.service';
import { CustomIconService } from './services/custom-icon.service';
import { FormsModule } from '@angular/forms';
import { FontStyleComponent } from './dropdowns/font-style/font-style.component';
import { FontComponent } from './dropdowns/font/font.component';
import { FontSizeComponent } from './dropdowns/font-size/font-size.component';
import { FontColorComponent } from './dropdowns/font-color/font-color.component';
import { FontHighlightComponent } from './dropdowns/font-highlight/font-highlight.component';

@NgModule({
  declarations: [
    CustomEditorComponent,
    NoteDropdownComponent,
    SpecialCharDropdownComponent,
    AccentedCharDropdownComponent,
    BibleDropdownComponent,
    LegalCodeDropdownComponent,
    MishnaDropdownComponent,
    TalmudBavliDropdownComponent,
    TalmudYerushalmiDropdownComponent,
    ToseftaDropdownComponent,
    FontStyleComponent,
    FontComponent,
    FontSizeComponent,
    FontColorComponent,
    FontHighlightComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    FateModule,
    FateMaterialModule
  ],
  exports: [
    FateModule,
    FateMaterialModule,
    CustomEditorComponent,
  ],
  providers: [
    {provide: FateHtmlParserService, useClass: CustomHtmlParserService},
    {provide: FateParserService, useClass: CustomParserService},
    {provide: FateIconService, useClass: CustomIconService}
]
})
export class CustomEditorModule { }
